import { lazy, Suspense } from "react";
import Loader from "../components/loaders/loader";
import { Route, Routes } from "react-router-dom";

const Dashboard = lazy(() => import("../features/dashboard"));
const SEOContent = lazy(() => import("../features/seo"));
const Login = lazy(() => import("../features/login"));
const SsoPage = lazy(() => import("../features/login/ssoPage"));
const User = lazy(() => import("../features/userManager/users"));
const ModuleRolePermission = lazy(() => import("../features/userManager/moduleRolePermission"));
const UserRoleMapping = lazy(() => import("../features/userManager/userRoleMapping"));
const Region = lazy(() => import("../features/packageManager/region"));
const Country = lazy(() => import("../features/packageManager/country"));
const State = lazy(() => import("../features/packageManager/state"));
const Unauthorized = lazy(() => import("../features/unauthorized"));
const City = lazy(() => import("../features/packageManager/city"));
const TourCategory = lazy(() => import("../features/packageManager/tourCategory"));
const Discount = lazy(() => import("../features/packageManager/discount"));
const SpecialityTours = lazy(() => import("../features/packageManager/specialityTours"));
const SupplierPay = lazy(() => import("../features/manageSupplier/supplierPay"));
const Suppliers = lazy(() => import("../features/manageSupplier/suppliers"));
const PackageCategory = lazy(() => import("../features/packageManager/packageCategory"));
const Packages = lazy(() => import("../features/packages/package/packagesList"));
const HomeSlider = lazy(() => import("../features/packages/homeSlider"));
const DestinationHot = lazy(() => import("../features/packages/destinationHot"));
const BestTourPackages = lazy(() => import("../features/packages/bestTourPackages"));
const HomeBlogOthers = lazy(() => import("../features/packages/homeBlogOthers"));
const TrendingPackage = lazy(() => import("../features/packages/trendingPackage"));
const Video = lazy(() => import("../features/packageManager/video"));
const Photo = lazy(() => import("../features/packageManager/photo"));
const HeaderMegaMenu = lazy(() => import("../features/packageManager/headerMegaMenu"));
const CompanyDetails = lazy(() => import("../features/company"));
const UserCompanyMapping = lazy(() => import("../features/userManager/userCompanyMapping"));

const AboutUs = lazy(() => import("../features/websiteContent/aboutUs"));
const ContactUs = lazy(() => import("../features/websiteContent/contactUs"));
const WhyUs = lazy(() => import("../features/websiteContent/whyUs"));
const Article = lazy(() => import("../features/websiteContent/article"));
const Blog = lazy(() => import("../features/websiteContent/blog"));
const UserFeedback = lazy(() => import("../features/websiteContent/userFeedback"));
const Career = lazy(() => import("../features/websiteContent/career"));
const FAQ = lazy(() => import("../features/websiteContent/FAQ"));
const VisaDocuments = lazy(() => import("../features/websiteContent/visaDocuments"));
const VisaAssistance = lazy(() => import("../features/websiteContent/visaAssistance"));
const HealthandMedical = lazy(() => import("../features/websiteContent/healthandMedical"));
const FirstTraveller = lazy(() => import("../features/websiteContent/firstTraveller"));
const ManageHeading = lazy(() => import("../features/websiteContent/manageHeading"));
const Member = lazy(() => import("../features/websiteContent/member"));
const WhatWeDo = lazy(() => import("../features/websiteContent/whatWeDo"));
const GroupsAndWeddings = lazy(() => import("../features/websiteContent/groupsAndWeddings"));
const NewsRoom = lazy(() => import("../features/websiteContent/newsRoom"));
const WhyChoose = lazy(() => import("../features/websiteContent/whyChoose"));
const TermsCondition = lazy(() => import("../features/websiteContent/termsCondition"));
const PRCPolicy = lazy(() => import("../features/websiteContent/prcPolicy"));

const EnquiryNow = lazy(() => import("../features/enquiry"));
const AddQueryView = lazy(() => import("../features/enquiry/AddQueryView"));
const Booking = lazy(() => import("../features/booking"));
const ProformaInvoice = lazy(() => import("../features/proformaInvoice"));
const AgentRegistration = lazy(() => import("../features/proformaInvoice/agent"));
const ExternalGuest = lazy(() => import("../features/externalGuest"));

const CampaignBuilder = lazy(() => import("../features/campaign/campaign/campaignBuilder"));
const CampaignList = lazy(() => import("../features/campaign/campaign/campaignList"));
const ContactList = lazy(() => import("../features/campaign/contact/contactList"));
const ContactGroup = lazy(() => import("../features/campaign/contact/group"));
const AddNewContact = lazy(() => import("../features/campaign/contact/addNewContact"));
const TmsRoutePage = lazy(() => import("../features/tms/TmsRoutePage"));
const TrafficDashboard = lazy(() => import("../features/trafficDashboard"));

export default function Router({ value }: any) {
    return (
        <>
            <Suspense fallback={<div><Loader /></div>}>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/sso" element={<SsoPage />} />
                    <Route path='/dashboard' element={<Dashboard />} />
                    <Route path='/users' element={<User />} />
                    <Route path='/modulepermission' element={<ModuleRolePermission />} />
                    <Route path='/rolemapping' element={<UserRoleMapping />} />
                    <Route path='/region' element={<Region />} />
                    <Route path='/country' element={<Country />} />
                    <Route path='/state' element={<State />} />
                    <Route path='/city' element={<City />} />
                    <Route path='/tourCategory' element={<TourCategory />} />
                    <Route path='/discount' element={<Discount />} />
                    <Route path='/specialityTours' element={<SpecialityTours />} />
                    <Route path='/supplierPay' element={<SupplierPay />} />
                    <Route path='/suppliers' element={<Suppliers />} />
                    <Route path='/packageCategory' element={<PackageCategory />} />
                    <Route path='/packages/:decodeType' element={<Packages />} />
                    <Route path='/homeslider' element={<HomeSlider />} />
                    <Route path='/destinationhot' element={<DestinationHot />} />
                    <Route path='/besttourpackages' element={<BestTourPackages />} />
                    <Route path='/homeblogothers' element={<HomeBlogOthers />} />
                    <Route path='/trendingpackages' element={<TrendingPackage />} />
                    <Route path='/video' element={<Video />} />
                    <Route path='/photo' element={<Photo />} />
                    <Route path='/aboutUs' element={<AboutUs />} />
                    <Route path='/contactUs' element={<ContactUs />} />
                    <Route path='/whyUs' element={<WhyUs />} />
                    <Route path='/article' element={<Article />} />
                    <Route path='/blog' element={<Blog />} />
                    <Route path='/review' element={<UserFeedback feedbackType="review" />} />
                    <Route path='/testimonial' element={<UserFeedback feedbackType="testimonial" />} />
                    <Route path='/career' element={<Career />} />
                    <Route path='/faq' element={<FAQ />} />
                    <Route path='/visadocuments' element={<VisaDocuments />} />
                    <Route path='/visa-assistance' element={<VisaAssistance />} />
                    <Route path='/healthandmedical' element={<HealthandMedical />} />
                    <Route path='/firsttraveller' element={<FirstTraveller />} />
                    <Route path='/manageheading' element={<ManageHeading />} />
                    <Route path='/member' element={<Member />} />
                    <Route path='/whatwedo' element={<WhatWeDo />} />
                    <Route path='/groupsandweddings' element={<GroupsAndWeddings />} />
                    <Route path='/newsroom' element={<NewsRoom />} />
                    <Route path='/whychoose' element={<WhyChoose />} />
                    <Route path='/termscondition' element={<TermsCondition />} />
                    <Route path='/Policy' element={<PRCPolicy />} />
                    <Route path='/enquiry' element={<EnquiryNow />} />
                    <Route path='/enquirynow' element={<EnquiryNow />} />
                    <Route path='/enquirylist' element={<EnquiryNow />} />
                    <Route path='/enquiry-list' element={<EnquiryNow />} />
                    <Route path='/cancelenquirylist' element={<EnquiryNow />} />
                    <Route path='/cancel-enquiry-list' element={<EnquiryNow />} />
                    <Route path='/addenquiry' element={<AddQueryView />} />
                    <Route path='/add-enquiry' element={<AddQueryView />} />
                    <Route path='/booking' element={<Booking />} />
                    <Route path='/bookinglist' element={<Booking />} />
                    <Route path='/addbooking' element={<Booking />} />
                    <Route path='/proforma' element={<Booking />} />
                    <Route path='/generateQuotation' element={<ProformaInvoice />} />
                    <Route path='/agentRegistration' element={<AgentRegistration />} />
                    <Route path='/externalguest' element={<ExternalGuest />} />
                    <Route path='/seo' element={<SEOContent />} />
                    <Route path='/campaign-builder' element={<CampaignBuilder />} />
                    <Route path='/campaigns' element={<CampaignList />} />
                    <Route path='/contact-list' element={<ContactList />} />
                    <Route path='/contact-group' element={<ContactGroup />} />
                    <Route path='/add-new-contact' element={<AddNewContact />} />
                    <Route path='/header-mega-menu' element={<HeaderMegaMenu />} />
                    <Route path='/traffic-dashboard' element={<TrafficDashboard />} />
                    <Route path='/company-details' element={<CompanyDetails />} />
                    <Route path='/user-company-mapping' element={<UserCompanyMapping />} />

                    <Route path='/unauthorized' element={<Unauthorized />} />
                    <Route path='*' element={<TmsRoutePage />} />

                </Routes>
            </Suspense>
        </>
    )
}